module.exports = __webpack_public_path__ + "img/20201107_203914.c6bdbb54.jpg";